import styled, {css, keyframes} from "styled-components"
import { BiDownArrowAlt, BiUpArrowAlt } from "react-icons/bi"
import { FaCaretRight, FaCaretLeft } from "react-icons/fa"
import { ScrollWrap } from "./CommonStyles"

// const widthAnim = ({hotbar}) => keyframes`
//   0% {
//     width: 0;
//   }
//   100% {
//     width: ${hotbar}%;
//   }
// `

const BuyItem = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    width: 100%;
    cursor: pointer;

    ${props => props.active >= props.idx && css`
        &::after{
            content: " ";
            width: calc(100% + 30px);
            height: 100%;
            position: absolute;
            left: -15px;
            background-color: #b7bdc620;
            ${props => props.active === props.idx && css`
                height: calc(100% - 1px);
                border-bottom: 1px dashed ${props => props.theme.color};
            `}
        }
    `}

    &::before{
        content: " "; 
        position: absolute;
        transition: all 0.3s;
        height: 100%;
        background-color: ${props => props.theme.mainGreen}15;
        width: ${({hotbar}) => hotbar > 100 ? 100 : hotbar}%;
    }

`

const SellItem = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    width: 100%;
    cursor: pointer;

    ${props => (props.idx >= props.active && props.active !== -1) && css`
        &::after{
            content: " ";
            width: calc(100% + 30px);
            height: 100%;
            left: -15px;
            position: absolute;
            background-color: #b7bdc620;
            ${props => props.active === props.idx && css`
                height: calc(100% - 1px);
                border-top: 1px dashed ${props => props.theme.color};
            `}
        }
    `}


    &::before{
        content: " ";
        position: absolute;
        transition: all 0.3s;
        height: 100%;
        background-color: ${props => props.theme.mainRed}15;
        width: ${({hotbar}) => hotbar > 100 ? 100 : hotbar}%;
        
    }

`


const UpArrow = styled(BiUpArrowAlt)`
    color: ${props => props.theme.mainGreen};
`

const DownArrow = styled(BiDownArrowAlt)`
    color: ${props => props.theme.mainRed};
`

const RightArrow = styled(FaCaretRight)`
    color: #5e6673;
`

const LeftArrow = styled(FaCaretLeft)`
    color: #5e6673;
`

const OrderBookTooltipBody = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 10;
  transition: all 0.1s;
  top: ${props => props.top - 50}px;
  ${props => props.isRight && css`
    right: -220px;
    flex-direction: ${props => props.theme.english ? 'row' : 'row-reverse'};
  `};

  ${props => !props.isRight && css`
    left: -220px;
    flex-direction: ${props => props.theme.english ? 'row-reverse' : 'row'};
  `};
`

const TooltipArrow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`


const OrderTooltip = styled.div`
    width: 200px;
    height: 120px;
    padding: 10px;
    margin: 0 -5px;
    border-radius: 4px;
    background-color: ${props => props.theme.orderHover};
    color: ${props => props.theme.primary};
`

const OrdersScrollWrap = styled(ScrollWrap)`
    height: calc(100% - 100px);
    padding: 0 0 0 4px;

    @media screen and (max-width: 1050px){
        height: 220px;
    };

`

const OrdersHeader = styled.div`
    width: 100%;
    height: 60px;
    background-color: ${({ theme }) => theme.mainBg};
    z-index: 1;
    position: relative;
`

const MobileHoverWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 100;
  padding: 10px 10px;
  width: 180px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #5e6673;
`



export {
    BuyItem,
    SellItem,
    UpArrow,
    DownArrow,
    RightArrow,
    LeftArrow,
    TooltipArrow,
    OrderTooltip,
    OrdersScrollWrap,
    OrdersHeader,
    MobileHoverWrapper,
    OrderBookTooltipBody
}
